import { Box, Button, FlexBox, Icon, Typography, getTokenCssVar } from '@vp/swan';
import { __ } from '@99designs/i18n';

export type ChatMessageLimitCardProps = {
    onReview: () => void;
};

/**
 * Shown in the composer's slot once the conversation has reached its message cap,
 * replacing the composer entirely.
 */
export function ChatMessageLimitCard({ onReview }: ChatMessageLimitCardProps) {
    return (
        <Box
            style={{
                backgroundColor: getTokenCssVar('SwanSemColorBgActive'),
                border: `1px solid ${getTokenCssVar('SwanSemColorBorderStandard')}`,
                borderBottom: 'none',
                borderRadius: `${getTokenCssVar('SwanSemBorderRadiusStandard')} ${getTokenCssVar(
                    'SwanSemBorderRadiusStandard'
                )} 0 0`,
                padding: getTokenCssVar('SwanSemSpace6'),
            }}
        >
            <FlexBox alignItems="center" gap={3} mb={5}>
                <Icon iconType="polish" size="standard" skin="accent" />
                <Typography fontSkin="title-item">
                    {__('Almost there...', {
                        _context: 'Heading on the chat brief message-limit card.',
                    })}
                </Typography>
            </FlexBox>
            <Box as="ul" style={{ margin: 0, paddingLeft: getTokenCssVar('SwanSemSpace5') }}>
                <Typography as="li" fontSkin="body-standard" mb={2}>
                    {__('There are a few details left to fill in', {
                        _context: 'List item on the chat brief message-limit card.',
                    })}
                </Typography>
                <Typography as="li" fontSkin="body-standard" mb={2}>
                    {__('You can complete them on the review page', {
                        _context: 'List item on the chat brief message-limit card.',
                    })}
                </Typography>
                <Typography as="li" fontSkin="body-standard" mb={5}>
                    {__('Once you submit, a designer will start working on your design', {
                        _context: 'List item on the chat brief message-limit card.',
                    })}
                </Typography>
            </Box>
            <Button skin="primary" iconPosition="left" onClick={onReview}>
                <Icon iconType="invoice" size="small" />
                {__('Review your brief', {
                    _context:
                        'Primary button on the chat brief message-limit card, taking the customer to review their brief.',
                })}
            </Button>
        </Box>
    );
}
